import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext.js';
import '../parents/AllParents.css';

function NewParent() {
  const navigate = useNavigate();
  const token = sessionStorage.getItem('jwtToken');
  const { userInfo } = useAuth();
  const { role, is_single_user, user_location_ids } = userInfo;

  const [values, setValues] = useState({
    firstname: '',
    lastname: '',
    email: '',
    mobile: '',
    beroep: '',
    iscontactperson: false,
    location_id: ''
  });
  const [locations, setLocations] = useState([]);
  const [emailExists, setEmailExists] = useState(false);
  const [loading, setLoading] = useState(false);

  axios.defaults.withCredentials = true;

  useEffect(() => {
    if (role === 'super_admin') {
      axios.get(`${process.env.REACT_APP_BACKEND_URL}/location/allLocations`, {
        headers: {
          Authorization: `Bearer ${token}`        }
      })
        .then(res => {
          const locs = res.data.data || res.data;
          setLocations(Array.isArray(locs) ? locs : []);
        })
        .catch(err => console.error('Error fetching locations', err));
    }
  }, [role, token]);

  const handleEmailBlur = async () => {
    if (!values.email) return;
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/auth/check-email-existence`,
        { params: { email: values.email }, headers: { Authorization: `Bearer ${token}` } }
      );
      setEmailExists(res.data.exists);
    } catch (err) {
      console.error('Error checking email', err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (emailExists) {
      alert('Het e-mailadres bestaat al.');
      return;
    }
    setLoading(true);
    try {
      const payload = { ...values };
      // if not super_admin, set location to first user_location_ids
      if (role !== 'super_admin') {
        payload.location_id = user_location_ids?.[0] || null;
      }
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/parent/newparent`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      navigate('/ouders');
    } catch (err) {
      console.error('Fout bij toevoegen ouder', err);
      alert('Kon ouder niet aanmaken.');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => navigate('/ouders');

  return (
    <div className="bg-white p-4 new-parent">
      <h2 className="text-center">Nieuwe Ouder</h2>
      <hr className="separator" />
      <form onSubmit={handleSubmit}>
        <div className="row mb-3">
          <div className="col">
            <label>Voornaam <span className="text-danger">*</span></label>
            <input
              type="text"
              className="form-control rounded-0"
              required
              value={values.firstname}
              onChange={e => setValues({ ...values, firstname: e.target.value })}
            />
          </div>
          <div className="col">
            <label>Achternaam <span className="text-danger">*</span></label>
            <input
              type="text"
              className="form-control rounded-0"
              required
              value={values.lastname}
              onChange={e => setValues({ ...values, lastname: e.target.value })}
            />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col">
            <label>Email <span className="text-danger">*</span></label>
            <input
              type="email"
              className="form-control rounded-0"
              required
              value={values.email}
              onChange={e => { setValues({ ...values, email: e.target.value }); setEmailExists(false); }}
              onBlur={handleEmailBlur}
            />
            {emailExists && <div className="text-danger">Dit e-mailadres is al in gebruik.</div>}
          </div>
          <div className="col">
            <label>Mobiel</label>
            <input
              type="text"
              className="form-control rounded-0"
              value={values.mobile}
              onChange={e => setValues({ ...values, mobile: e.target.value })}
            />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col">
            <label>Opleidingsniveau</label>
            <input
              type="text"
              className="form-control rounded-0"
              value={values.beroep}
              onChange={e => setValues({ ...values, beroep: e.target.value })}
            />
          </div>
          
          <div className="col d-flex align-items-end">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                checked={values.iscontactperson}
                onChange={e => setValues({ ...values, iscontactperson: e.target.checked })}
              />
              <label className="form-check-label">Contactpersoon</label>
            </div>
          </div>
        </div>

        {!is_single_user && role === 'super_admin' && (
          <div className="mb-3">
            <label>Locatie</label>
            <select
              className="form-select rounded-0"
              value={values.location_id || ''}
              onChange={e => setValues({ ...values, location_id: e.target.value })}
            >
              <option value="">-- Kies locatie --</option>
              {locations.map(loc => (
                <option key={loc.location_id} value={loc.location_id}>{loc.location_name}</option>
              ))}
            </select>
          </div>
        )}

        <hr className="separator" />
        <div className="row">
          <div className="col-md-6 mb-2">
            <button type="button" className="btn btn-secondary w-100 rounded-0" onClick={handleCancel}>Annuleren</button>
          </div>
          <div className="col-md-6">
            <button type="submit" className="btn btn-primary w-100 rounded-0" disabled={loading}>
              {loading ? 'Opslaan...' : 'Opslaan'}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default NewParent;
